<a
  [attr.href]="href"
  [attr.target]="openInNewTab ? '_blank' : null"
  trackable
  [trackingObject]="trackingObject"
  [trackingAction]="trackingAction"
  [trackingAdditionalProperties]="trackingAdditionalProperties"
>
  <app-icon *ngIf="icon" [icon]="icon"> </app-icon>

  {{ label }}
</a>
